import { CUSTOMER_ROUTE_SEGMENTS } from "../../shared/routing/paths/customer";
import { emissionFactorsLibraryLabels } from "./labels/emission-factors-library-labels";
import { MyEmissionFactorsLibraryPage } from "./lazy-pages";

export const CustomerEmissionFactorsRoutes = {
  path: CUSTOMER_ROUTE_SEGMENTS.emissionFactorsLibrary,
  handle: { crumb: emissionFactorsLibraryLabels.breadcrumb },
  element: <MyEmissionFactorsLibraryPage />,
};
